const reviewLinks = document.querySelectorAll('a[href="#judgeme_product_reviews"]');
if (reviewLinks?.length > 0) {
  reviewLinks.forEach((reviewLink) => {
    reviewLink.addEventListener('click', (e) => {
      e.preventDefault(); // prevent url change
      const reviews = document.querySelector('#judgeme_product_reviews');
      const reviewsPanelId = reviews.closest('.panel').id;
      const reviewsTab = document.querySelector(`[aria-controls="${reviewsPanelId}"]`);
      reviewsTab.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      reviewsTab.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    });
  });
}
